import {
  IonButton,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonToggle,
  useIonAlert,
  useIonToast,
  useIonViewDidEnter,
  useIonViewDidLeave,
} from '@ionic/react';

import { help, infinite, lockClosed, lockOpen, logIn, logOut, logoWhatsapp, mailOutline, searchCircle, syncCircle, warning } from 'ionicons/icons';
import './Menu.css';
import { _SMALL_SCREEN_WIDTH, _appVersion, _bulkImportPage, _debugMode, _defaultButtonColor, _defaultButtonColorLighter, _dict, _freeCards, _lang, _languages, _parentMode, _rootName } from './constants';
import { encryptData, goToContacts, goToWhatsApp } from './foo';
import { rateLimitedSync } from './sync';
import { goToPayment } from './payments';
import { FullscreenButton } from './Fullscreen';
import { useUIStore } from './stateManagement/UIZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import { useUserStore } from './stateManagement/userZustand';
import { menuController } from '@ionic/core';
import UpdateButton from './UpdateSection';
import { logMe } from '../foo/user';
import { useHistory } from 'react-router';
import ButtonTemplate from './templates/ButtonTemplate';
import { useURLStore } from './stateManagement/URLZustand';

 
      


const Menu: React.FC = () => {
  const { setIsMenuOpen,
    setIsEnterCodeDialogOpen, setIsSetNewCodeDialogOpen, windowSize } = useUIStore();
  
  const { isParentMode, setIsParentMode, lang, updateLang, homeNodePath,
    setHomeNodePath, topSentences, pwd, setPwd } = useGlobalStore();
  const {
    nodes, l2Image, l2Audio: l2audio, l2Visibility: l2visibility, l2Color: l2color,
    setNodes, setL2Audio, setL2Image, setL2Visibility, setL2Color, nodesCount
   } = useTreeStore();
  const { userUniqueId, userEmail, isSubscribed, handleLogout } = useUserStore();
  const [ present ] = useIonToast();
  const history = useHistory();
  const { getURLTo, URLVars } = useURLStore();

  
  // This should solve the error: "ASSERT: _before() should not be called while animating" 
  // occurring while opening the menu.
  useIonViewDidEnter(() => {
    menuController.enable(true);
  });
  useIonViewDidLeave(() => {
    setTimeout(() => {
        // to stop bug as cannot set enable to false whilst it is animating closed
        menuController.enable(false);
    }, 300);
  });


  const presentToast = (position: 'top' | 'middle' | 'bottom') => {
    present({
      message: _dict.wrongPswMsg[lang],
      duration: 0,
      position: position,
      icon: warning,
      buttons: [
      {
        text: _dict.reqNewPassword[lang],
        handler: () => {logMe("click_change_code",{});PswScreen()}
      }, {
        text: _dict.dismissToast[lang],
        role: 'cancel'
      },]
      
    });
  };


  const [presentAlert, dismissPresentAlert ] = useIonAlert();
  const [nextAlert] = useIonAlert();
  
  const executeSync = async (clearData:boolean, keepLocal:boolean) => {
   
    
    const res = await rateLimitedSync(nodes, l2Image, l2audio, l2visibility, l2color,
      userUniqueId, userEmail,
      setNodes, setL2Audio, setL2Image, setL2Visibility, setL2Color,
      keepLocal, clearData, homeNodePath,
      setHomeNodePath, topSentences
      ); //REF-1

    if(_debugMode){console.log("Synch result = ",res)}
    if(res == true){
      presentAlert({header: _dict.syncDone[lang]})
    }else{
      presentAlert({header: _dict.syncProblem[lang]})
    }
  }

  const SyncScreen_Step1 = () => presentAlert({
    header: _dict.chooseSyncOpt[lang],
    buttons: [
      {
        text: _dict.mergeData[lang],
        handler: async () => {
          SyncScreen_Step2(false, null);
        }
      },
      {
        text: _dict.overwriteRemote[lang],
        handler: () => {
          SyncScreen_Step2(true, true);
        }
      },
      {
        text: _dict.overwriteLocal[lang],
        handler: () => {
          SyncScreen_Step2(true, false);
        }
      },
      {
        text: _dict.syncBack[lang],
        role: 'cancel'
      }
    ],
    

  });



 const SyncScreen_Step2 = (clearData:boolean, keepLocal:boolean | null) => {
    if(clearData == false){
      return nextAlert({
        header: _dict.syncMsg[lang],
        buttons: [
          {
            text: _dict.keepLocal[lang],
            handler: async () => {
              executeSync(clearData, true);
            }
          },
          {
            text: _dict.keepRemote[lang],
            handler: () => {
              executeSync(clearData, false);
            }
          },
          {
            text: _dict.syncBack[lang],
            role: 'cancel'
          }
        ]
        });
    }else if(clearData===true && keepLocal===true){
      return nextAlert({
        header: _dict.confirmDelRemote[lang],
        buttons: [
          {
            text: _dict.yes[lang],
            handler: async () => {
              executeSync(clearData, true);
            }
          },
          {
            text: _dict.no[lang],
            role: 'cancel'
          }
        ]
        })
      }else if(clearData===true && keepLocal===false){
        return nextAlert({
          header: _dict.confirmDelLocal[lang],
          buttons: [
            {
              text: _dict.yes[lang],
              handler: async () => {
                executeSync(clearData, false);
              }
            },
            {
              text: _dict.no[lang],
              role: 'cancel'
            }
          ]
          })
        }
    };
  
  const SyncPremiumScreen = () => presentAlert({    
    header: _dict.syncPremiumHeader[lang],
    message: _dict.syncPremiumMsg[lang],
    buttons: [{
      text: _dict.freeQuotaPremiumBtnText[lang],
      handler: async () => { logMe("click_premium",{from:"SyncPremiumScreen"}); goToPayment(userUniqueId) }
    }]
  });

  const handleEnterNewPwd = async () => {
    const passwordInput = document.querySelector('input[type="password"]') as HTMLInputElement;
    let entered = passwordInput.value;
    const toStore = await encryptData(entered, userUniqueId);
    setPwd(toStore);
    setIsParentMode(false);
    dismissPresentAlert();
    // Reload window
    window.location.reload();
  }

  const PswScreen = () => presentAlert({
    header: _dict.enterPswMsg[lang],
    message: _dict.dontWorryYouCanEasilyChangeItLater[lang],
    buttons: [{
      text: 'OK',
      handler: async (form:any) => {
        handleEnterNewPwd()
      }
    }],
    cssClass: 'tourStep2', // Do not delete, since it is used for auto-focus
    inputs: [
      {
        name: 'pwd',
        type: 'password',
        placeholder: '',
        attributes: {
          maxlength: 10,
          minlength: 3,
          onKeyUp: async (event:any) => {
            if (event.key === 'Enter') {
              handleEnterNewPwd();
            }
          }
        }
      },
    ],
    onDidDismiss: async (event) => {
      setIsSetNewCodeDialogOpen(false);
      handleEnterNewPwd();
    },
    onDidPresent: async (event) => {
      setIsSetNewCodeDialogOpen(true);
      // AUTO-FOCUS:
      setTimeout(() => {
        const input = document.querySelector('.tourStep2 input') as HTMLInputElement;
        // Usage:
        if (input) {
          input.focus();
        }
    }, 400); // Adjust timeout as necessary
      
    }
  });

  const handleDismissEnterPswScreen = async (pwd:string) => {
    
    const passwordInput = document.querySelector('input[type="password"]') as HTMLInputElement;
    let entered = passwordInput.value;
    const enteredEnc = await encryptData(entered, userUniqueId);
    
    if(enteredEnc.replace(/\n/g, '').trim() == pwd.replace(/\n/g, '').trim()){
      setIsParentMode(true);
    }else{ 
      setIsParentMode(false);
      presentToast('top');
      logMe("wrong_code",{});
    }
    dismissPresentAlert();
  }

  const searchButton = <ButtonTemplate
  icon={searchCircle} text={_dict.search[lang]} onClick={() => {
    logMe("click_stories", {});
    history.push(getURLTo().stories());
    // Reload
    window.location.reload();
  }} />;
  
  const helpButton = <ButtonTemplate icon={help} text={_dict.ask[lang]} onClick={() => {
    logMe("click_help", {});
    history.push(getURLTo().help());
    // Reload
    window.location.reload();
  }} />;
  
  const EnterPswScreen = (pwd: any) => presentAlert({
    buttons: [{
      text: 'OK'
    }],
    cssClass: 'tourStep4', // Do not delete, since it is used for auto-focus
    inputs: [
      {
        name: 'pwd',
        type: 'password',
        placeholder: _dict.code[lang],
        attributes: {
          maxlength: 10,
          minlength: 3,
          onKeyUp: async (event: any) => {
            if (event.key === 'Enter') {
              handleDismissEnterPswScreen(pwd);
            }
          }
        }
      },
    ],
    onDidDismiss: async (event) => {
      setIsEnterCodeDialogOpen(false);
      handleDismissEnterPswScreen(pwd);
    },
    onDidPresent: async (event) => {
      setIsEnterCodeDialogOpen(true);
      // AUTO-FOCUS:
      setTimeout(() => {
        const input = document.querySelector('.tourStep4 input') as HTMLInputElement;
        // Usage:
        if (input) {
          input.focus();
        }
      }, 400); // Adjust timeout as necessary
    }
  });
  

  const launchPswScreen = async () => {
    if(!isParentMode){
      if(pwd){
        if(pwd){
          EnterPswScreen(pwd);
        }else{
          PswScreen();
        }
      }else{
        PswScreen();
      }
    }else{
      setIsParentMode(false);
    }
  }

  const settings = <IonList>
  <IonItem  >
    <IonSelect label={_dict.language[lang]} value={lang} onIonChange={(v) => updateLang(v.target.value)}>
      {_languages.map((el) => (
        <IonSelectOption key={el} value={el} >
          {_dict.lang[el]}
        </IonSelectOption>
      ))}
    </IonSelect>
  </IonItem>
  
</IonList>;

  //console.log(collectLists(nodes));
  const syncButton = <IonButton color="light" expand="block" fill="solid"  onClick={async () => {if(isSubscribed === false){SyncPremiumScreen()}else{ SyncScreen_Step1(); }}}>{_dict.sync[lang]}<IonIcon size="small" icon={syncCircle} slot="end" /></IonButton>;
  //const syncButton = <IonButton color="light" expand="block" fill="solid"  onClick={async () => {if(!isSubscribed){SyncPremiumScreen()}else{ SyncPremiumScreen2(); }}}>{_dict.sync[lang]}<IonIcon size="small" icon={syncCircle} slot="end" /></IonButton>;
  const contactButton = <IonButton  expand="block" color="primary" fill="clear" onClick={() => goToContacts(lang)}>
    <IonIcon icon={mailOutline} slot="start" />
    {_dict.contactMsg[lang]}
    </IonButton>;
  const whatsAppButton = <IonButton  expand="block" color="primary" fill="clear" onClick={() => {logMe("click_community",{from:"menu"});goToWhatsApp(lang)}}>
    <IonIcon icon={logoWhatsapp} slot="start" /> COMMUNITY
  </IonButton>;
  const logoutButton = <IonButton  expand="block"  color="light" onClick={() => {handleLogout(); window.location.reload()}} >{_dict.logout[lang]}<IonIcon icon={logOut} slot="end"/></IonButton>
  //const resetButton  = <IonButton className="ion-margin"  color="light" onClick={() => {clearCache();}} >{_dict.reset[lang]}<IonIcon icon={refreshOutline} slot="start"/></IonButton>

  const versionSnippet = <div className="ion-text-center" style={{ fontSize: '0.8rem', background:"transparent", width:"100%" }}>
    {"DSApp v"+_appVersion}
      
    </div>
  

  
  const cleanBtn = <UpdateButton text={_dict.clean[lang]} />
  
  const handleEmailClick = () => {
    if(userEmail === "" || userEmail === undefined || userEmail === null){
      history.push("/login");
      window.location.reload();
    }
  }

  
  return (
    <>
    
    <IonMenu side="start" contentId="main" type="overlay"
    menuId="firstMenu"
    onIonDidOpen={() => {setIsMenuOpen(true); logMe("click_openMenu",{});}}
    onIonDidClose={() => setIsMenuOpen(false)}
    
    >
      <IonContent>
        {isParentMode && userEmail ? syncButton : null}
        
        {windowSize.width < _SMALL_SCREEN_WIDTH && <IonGrid>
          <IonRow>
          <IonCol size="6" class="ion-text-center">
            {searchButton} 
          </IonCol>
          <IonCol size="6" class="ion-text-center">
            {helpButton}
          </IonCol></IonRow></IonGrid>}
        <IonItem lines="none">
          
        
          <IonChip outline={true} style={{whiteSpace: 'nowrap'}}>{_dict.cards[lang]}: {nodes ? nodesCount : null}</IonChip>
          <IonChip color="primary">
            <IonIcon icon={mailOutline} />
            <IonLabel onClick={handleEmailClick}>{userEmail ? userEmail : _dict.noUserPleaseLogin[lang]}</IonLabel>
          </IonChip>
          {/*<IonChip outline={true} color={isSubscribed === false && nodesCount > _freeCards ? "danger" : "dark" }>{_dict.remainingCards[lang]}: { isSubscribed === true ?  <IonIcon icon={infinite} />: _freeCards - nodesCount }</IonChip>*/}
        </IonItem>
        <IonItem >
          <IonMenuToggle key="lock" autoHide={false} >
            <IonItem routerDirection="none" lines="none" detail={false}>
              <IonIcon slot="start" ios={isParentMode ? lockOpen : lockClosed} md={isParentMode ? lockOpen : lockClosed} />
              <IonToggle
              color="warning" 
              slot="end" checked={isParentMode} onIonChange={ () => { setIsParentMode(!isParentMode); launchPswScreen(); } }>
                {_dict.parentMode[lang]}
              </IonToggle>
            </IonItem>
          </IonMenuToggle>
         
        </IonItem>
        
        { isParentMode && settings }
        <IonGrid>
       
        <IonRow>
          <IonCol size={isParentMode ? "6":"12"} >
            {cleanBtn}
          </IonCol>
          <IonCol size={isParentMode ? "6" : ""} >
            {isParentMode && userUniqueId && userEmail ? logoutButton: 
            userEmail === "" || userEmail === undefined || userEmail === null ?
              <IonButton
                color="dark"
                expand="block"
                fill="solid"
                onClick={() => {
                  history.push("/login");
                  window.location.reload();
                }}
                
              >
                {_dict.loginOnly[lang]}
                <IonIcon icon={logIn} slot="end" />
              </IonButton>
              

            : null}
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="6" offset="3">
            <FullscreenButton />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="6" offset="3">
            {isParentMode && contactButton}
            {isParentMode && whatsAppButton}
          </IonCol>
        </IonRow>
        {isParentMode && !isSubscribed && userEmail && <IonRow>
          <IonCol>
            <IonButton style={{"--background":_defaultButtonColor, borderRadius:"2px", width:"100%"}} onClick={() => {logMe("click_premium_menu"); goToPayment(userUniqueId)}}>
                {_dict.freeQuotaPremiumBtnText[lang]}
            </IonButton>
          </IonCol>
        </IonRow>}
        </IonGrid>
       
        
       
       {versionSnippet}
       
       
       </IonContent>
       
    </IonMenu>
    
    </>
  );
};

export default Menu;
